export enum EActionEvent {
  EDIT = 'EDIT',
  INFO = 'INFO',
  DOWNLOAD = 'DOWNLOAD',
  EYE = 'EYE',
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  RETRY = 'RETRY',
  APPLY_NOW = 'APPLY_NOW',
  PAY_CERTIFICATE = 'PAY_CERTIFICATE',
  REVIEW = 'REVIEW',
}